<h3 class="header-title">KeyAccounts</h3>
<nz-table
  [nzLoading]="isLoading"
  [nzData]="keyAccounts"
  [nzShowPagination]="false"
  [nzFrontPagination]="false"
  [nzSize]="'small'"
>
  <thead>
  <tr>
    <th>Name</th>
    <th>User Name</th>
    <th>Email</th>
    <th>Created by</th>
    <th>Created at</th>
    <th></th>
  </tr>
  </thead>
  <tbody>
  <tr *ngFor="let keyAccount of keyAccounts">
    <td>
      {{ keyAccount.name }}
      <nz-tag class="tag" [nzColor]="keyAccount.is_active ? 'success' : 'warning'">{{ keyAccount.is_active ? "Aktiv" : "Inaktiv" }}</nz-tag
    ></td>
    <td>{{ keyAccount.user_name }}</td>
    <td>{{ keyAccount.email }}</td>
    <td>{{ keyAccount.created_by }}</td>
    <td>{{ keyAccount.created_at | yomaDateFormat:'dd.MM.yyyy HH:mm' }}</td>
    <td>
  </tr>
  </tbody>

</nz-table>

<div class="statistic-container" *ngIf="keyAccounts.length">
  <user-stats class="statistic-item" [users]="keyAccounts" type="active" [title]="'Aktive vs. Inaktive'"></user-stats>
  <user-stats class="statistic-item" [users]="keyAccounts" type="created" [title]="'Anlage aktiver Großkunden durch Mitarbeiter'"></user-stats>
  <user-stats class="statistic-item" [users]="keyAccounts" type="created-by-month" [title]="'Freischaltungenim Zeitablauf'"></user-stats>
</div>
